export default __webpack_public_path__ + "static/media/success.02007e64.png";